"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_CATALOG = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_CATALOG = (0, gql_1.gql)(`
   mutation createCatalog($title: String!, $project: ID!, $description: String!) {
    catalog(title: $title, project: $project, description: $description) {
      id
      title
    }
  }
`);
